/* eslint-disable max-len */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RecipeCard from 'routes/Products/components/RecipeCard';
import { Button, Col, Row } from 'reactstrap';
import * as styles from 'styles/index.scss';
import { useWeek } from 'routes/Products/products/WLC/contexts/WeekContext';

const { recipesListRecipes } = styles;

const RecipesList = ({ className, colSizes, userAnalytics, disableViewAll }) => {
  const { recipesList } = useWeek();

  if (!recipesList) return null;

  const { data, Children = [] } = recipesList;
  const { description } = data || {};
  const path = location.pathname.split('/');
  const thisProductInPath = path[2];

  return (
    <div className={className}>
      <Row className="align-items-end">
        <Col xs="auto">
          <h4>Recipes to Try</h4>
        </Col>
      </Row>
      <Row className={`${recipesListRecipes} justify-content-center`} style={{ padding: 0 }} id="wlc-week-recipes-list">
        {Children.map((recipe, i) => (
          <Col key={recipe.slug || i} {...colSizes}>
            <RecipeCard {...recipe} className="h-100" />
          </Col>
        ))}
      </Row>
      <Row className="d-lg-none text-center">
        <Col xs={12}>
          <Button color="primary" size="lg" tag={Link} to={`/products/${thisProductInPath}/recipes`}>
            Explore All Recipes
          </Button>
        </Col>
      </Row>
    </div>
  );
};

RecipesList.propTypes = {
  className: PropTypes.string,
  colSizes: PropTypes.object,
  userAnalytics: PropTypes.object,
  disableViewAll: PropTypes.bool
};

RecipesList.defaultProps = {
  className: '',
  colSizes: {},
  userAnalytics: null,
  disableViewAll: false
};

export default RecipesList;
